export var LpInvestorFlow;
(function (LpInvestorFlow) {
    LpInvestorFlow["EULegalEntity"] = "eu-legal-entity";
    LpInvestorFlow["USLegalEntity"] = "us-legal-entity";
    LpInvestorFlow["UKLegalEntity"] = "uk-legal-entity";
    LpInvestorFlow["EUIndividual"] = "eu-individual";
    LpInvestorFlow["USIndividual"] = "us-individual";
    LpInvestorFlow["UKIndividual"] = "uk-individual";
})(LpInvestorFlow || (LpInvestorFlow = {}));
export var SpecialPartner;
(function (SpecialPartner) {
    SpecialPartner["No"] = "no";
    SpecialPartner["GeneralPartner"] = "generalPartner";
    SpecialPartner["BritishBusinessBank"] = "britishBusinessBank";
})(SpecialPartner || (SpecialPartner = {}));
//# sourceMappingURL=index.js.map